import React from 'react';
import OnMount from '@atlassian/jira-common-util-op-triggers/src/on-mount/OpTrigger.tsx';
import tagMauEvent from './tag-mau-event.tsx';
import type { SubProduct } from './types.tsx';

type Props = {
	subProduct: SubProduct;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ subProduct }: Props) => <OnMount op={tagMauEvent} args={[subProduct]} />;
